module.exports = __webpack_public_path__ + "img/DownloadVT.7ec1b82c.png";